/**
 * AIDisclosureBadge - Article 50 disclosure (D-AICP-06, CAND-T5-CAT30). A small, always-visible
 * badge disclosing that a surface involves AI interaction. Presentational only: it takes a
 * `staged` prop rather than inferring anything, so staged and live surfaces remain explicit.
 */
import { type ReactElement } from "react";
import { Sparkles } from "lucide-react";

interface AIDisclosureBadgeProps {
  staged: boolean;
  variant?: "badge" | "icon";
}

export function AIDisclosureBadge({
  staged,
  variant = "badge",
}: AIDisclosureBadgeProps): ReactElement {
  const label = staged ? "AI interaction - generation staged" : "AI interaction";

  if (variant === "icon") {
    return (
      <span
        role="img"
        aria-label={label}
        className="inline-flex shrink-0 items-center justify-center text-[var(--color-accent)]"
      >
        <Sparkles size={12} aria-hidden />
      </span>
    );
  }

  return (
    <span
      role="status"
      aria-label={label}
      className="inline-flex items-center gap-1 rounded-[var(--radius-sharp-outside)] border border-[var(--color-border-default)] bg-[var(--color-accent-subtle)] px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.06em] text-[var(--color-accent)]"
    >
      <Sparkles size={10} aria-hidden />
      {staged ? "AI - staged" : "AI"}
    </span>
  );
}
